module.exports = __webpack_public_path__ + "static/mw11-e5c65db6b600a79fe280cd7b106e564c.jpg";